import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import Tilt from 'react-parallax-tilt'

import ThemeMenuThree from '../../../components/header/ThemeMenuThree'
import PageTitle from '../../../components/page-title/PageTitle'
import FooterThree from '../../../components/footer/FooterThree'

const coreValues = [
    {
        icon: 'icon-18b.svg',
        title: '\uC131\uC7A5',
        desc: '\uAD6C\uC131\uC6D0 \uBAA8\uB450\uAC00 \uD568\uAED8 \uC131\uC7A5\uD558\uBA70, \uAC1C\uC778\uC758 \uC131\uC7A5\uC744 \uCF54\uB2F4\uC758 \uC131\uC7A5\uC73C\uB85C \uC774\uC5B4\uAC11\uB2C8\uB2E4.'
    },
    {
        icon: 'icon-19b.svg',
        title: '\uC2E0\uB8B0',
        desc: '\uD22C\uBA85\uD55C \uC18C\uD1B5\uACFC \uC218\uD3C9\uC801\uC778 \uBB38\uD654\uB85C \uC11C\uB85C\uB97C \uBBFF\uACE0 \uD611\uB825\uD558\uB294 \uD300\uC744 \uB9CC\uB4ED\uB2C8\uB2E4.'
    },
    {
        icon: 'icon-15b.svg',
        title: '\uD601\uC2E0',
        desc: '\uD604\uC0C1 \uC720\uC9C0\uC5D0 \uBA38\uBB3C\uC9C0 \uC54A\uACE0 \uB354 \uB098\uC740 \uBC29\uBC95\uC744 \uB04A\uC784\uC5C6\uC774 \uD0D0\uAD6C\uD558\uACE0 \uC2E4\uD589\uD569\uB2C8\uB2E4.'
    },
    {
        icon: 'icon-16b.svg',
        title: '\uC5F0\uACB0',
        desc: '\uAE30\uC220\uACFC \uC0AC\uB78C, \uAE30\uC5C5\uACFC \uC0AC\uD68C\uB97C \uC5F0\uACB0\uD574 \uB354 \uD070 \uAC00\uCE58\uB97C \uB9CC\uB4E4\uC5B4\uB0C5\uB2C8\uB2E4.'
    },
    {
        icon: 'icon-17b.svg',
        title: '\uB2E4\uC591\uC131',
        desc: '\uB2E4\uC591\uD55C \uBC30\uACBD\uACFC \uAD00\uC810\uC744 \uC874\uC911\uD558\uBA70, \uCC28\uC774\uAC00 \uC131\uACFC\uB85C \uC5F0\uACB0\uB418\uB294 \uBB38\uD654\uB97C \uB9CC\uB4ED\uB2C8\uB2E4.'
    },
    {
        icon: 'icon-20b.svg',
        title: '\uC9C0\uC18D\uAC00\uB2A5\uC131',
        desc: '\uB2E8\uAE30 \uC131\uACFC\uBCF4\uB2E4 \uC9C0\uC18D \uAC00\uB2A5\uD55C \uC131\uC7A5\uC744 \uC9C0\uD5A5\uD558\uBA70, \uC0AC\uB78C\uACFC \uD658\uACBD\uC744 \uACE0\uB824\uD55C \uC120\uD0DD\uC744 \uC2E4\uCC9C\uD569\uB2C8\uB2E4.'
    }
]

const benefitItems = [
    {
        icon: 'benefits/flexible-work.png',
        title: '\uC720\uC5F0 \uADFC\uBB34',
        desc: '\uC790\uC728 \uCD9C\uD1F4\uADFC \uC81C\uB3C4\uB85C \uAC01\uC790\uC758 \uB77C\uC774\uD504\uC2A4\uD0C0\uC77C\uC5D0 \uB9DE\uAC8C \uADFC\uBB34\uD569\uB2C8\uB2E4.'
    },
    {
        icon: 'benefits/remote-work.png',
        title: '\uC7AC\uD0DD \uADFC\uBB34',
        desc: '\uC5C5\uBB34 \uD2B9\uC131\uC5D0 \uB530\uB77C \uC790\uD0DD\uC5D0\uC11C\uB3C4 \uC0DD\uC0B0\uC801\uC73C\uB85C \uC77C\uD560 \uC218 \uC788\uB3C4\uB85D \uC9C0\uC6D0\uD569\uB2C8\uB2E4.'
    },
    {
        icon: 'benefits/learning.png',
        title: '\uD559\uC2B5 \uC9C0\uC6D0',
        desc: '\uB3C4\uC11C, \uAC15\uC758, \uCEF4\uD37C\uB7F0\uC2A4 \uB4F1 \uC131\uC7A5\uC744 \uC704\uD55C \uD559\uC2B5 \uBE44\uC6A9\uC744 \uC801\uADF9 \uC9C0\uC6D0\uD569\uB2C8\uB2E4.'
    },
    {
        icon: 'benefits/health.png',
        title: '\uAC74\uAC15 \uAD00\uB9AC',
        desc: '\uAC74\uAC15\uAC80\uC9C4\uACFC \uD53C\uD2B8\uB2C8\uC2A4 \uBE44\uC6A9 \uC9C0\uC6D0\uC73C\uB85C \uAC74\uAC15\uD55C \uC0DD\uD65C\uC744 \uB3D5\uC2B5\uB2C8\uB2E4.'
    },
    {
        icon: 'benefits/team-culture.png',
        title: '\uD300 \uBB38\uD654',
        desc: '\uC815\uAE30 \uD300\uBE4C\uB529\uACFC \uC6CC\uD06C\uC0F5\uC73C\uB85C \uD568\uAED8 \uC131\uC7A5\uD558\uB294 \uBB38\uD654\uB97C \uB9CC\uB4ED\uB2C8\uB2E4.'
    },
    {
        icon: 'benefits/equipment.png',
        title: '\uC7A5\uBE44 \uC9C0\uC6D0',
        desc: '\uC5C5\uBB34\uC5D0 \uD544\uC694\uD55C \uC7A5\uBE44\uB97C \uC785\uC0AC \uC2DC\uC810\uBD80\uD130 \uCDA9\uBD84\uD788 \uC9C0\uC6D0\uD569\uB2C8\uB2E4.'
    }
]

const About = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">
                <ThemeMenuThree />
                <PageTitle title="코담 문화" />

                <section className="codam-feature pt-120 pt-lg-80 pb-50 pb-lg-30">
                    <div className="container">
                        <div className="row align-items-center gx-4 gx-xxl-5">
                            <div className="col-lg-7">
                                <div className="section-title-two mb-25">
                                    <h6 className="sub-title mb-20">{'\uCF54\uB2F4\uC774 \uB9CC\uB4E4\uC5B4\uAC00\uB294 \uC77C\uD558\uB294 \uBC29\uC2DD'}</h6>
                                    <h2 className="sect-title">{'\uC0AC\uB78C\uC744 \uC911\uC2EC\uC5D0 \uB454 \uBB38\uD654\uB85C \uB354 \uB098\uC740 \uC11C\uBE44\uC2A4\uB97C \uB9CC\uB4ED\uB2C8\uB2E4'}</h2>
                                </div>
                                <p className="mb-0">
                                    {'\uCF54\uB2F4\uC758 \uBB38\uD654\uB294 \uAD6C\uC131\uC6D0\uC758 \uD589\uBCF5\uACFC \uC131\uC7A5\uC744 \uC911\uC2EC\uC5D0 \uB461\uB2C8\uB2E4.'}
                                    {'\uAC1C\uC778\uC758 \uC131\uC7A5\uC774 \uD300\uC758 \uC131\uC7A5\uC73C\uB85C \uC774\uC5B4\uC9C0\uACE0, \uD300\uC758 \uC131\uC7A5\uC774 \uACE0\uAC1D \uAC00\uCE58\uB85C \uC5F0\uACB0\uB41C\uB2E4\uACE0 \uBBFF\uC2B5\uB2C8\uB2E4.'}
                                </p>
                            </div>
                            <div className="col-lg-5">
                                <div className="about-img-wrapper-four codam-culture-visual position-relative mt-35 mt-lg-0">
                                    <Tilt
                                        tiltMaxAngleX={6}
                                        tiltMaxAngleY={6}
                                        scale={1.03}
                                        transitionSpeed={1400}
                                        glareEnable={false}
                                    >
                                        <img className="main-img w-100" src="assets/img/about/ilus-1c.svg" alt={ '\uCF54\uB2F4 \uCEEC\uCC98 \uC77C\uB7EC\uC2A4\uD2B8' } />
                                    </Tilt>
                                    <img className="shape-one" src="assets/img/shape/line-round-2a.svg" alt="shape" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="codam-core-values" className="counter-area codam-core-values pt-70 pb-100 pt-lg-30 pb-lg-30">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-12">
                                <div className="section-title-two text-center mb-45">
                                    <h6 className="sub-title mb-20">핵심 가치</h6>
                                    <h2 className="sect-title">{'\uCF54\uB2F4\uC758 \uD575\uC2EC \uAC00\uCE58'}</h2>
                                </div>
                            </div>
                            {coreValues.map((item) => (
                                <div key={item.title} className="col-md-6 col-xl-4 mb-35">
                                    <div className="feature-style-one h-100 mb-0">
                                        <span className="top-arrow" aria-hidden="true"><i className="bi bi-arrow-up-right" /></span>
                                        <img className="front-icon" src={`assets/img/icon/${item.icon}`} alt="" />
                                        <h2>{item.title}</h2>
                                        <p>{item.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="codam-price price-bg codam-benefits-perks pt-110 pb-80 pt-lg-60 pb-lg-40">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-12">
                                <div className="section-title-two text-center mb-45">
                                    <h6 className="sub-title mb-20">복지·혜택</h6>
                                    <h2 className="sect-title">{'\uCF54\uB2F4\uC774 \uC81C\uACF5\uD558\uB294 \uAC83\uB4E4'}</h2>
                                    <p className="mt-20 mb-0">{'\uAD6C\uC131\uC6D0\uC774 \uCD5C\uC120\uC744 \uB2E4\uD560 \uC218 \uC788\uB3C4\uB85D \uCF54\uB2F4\uC774 \uBA3C\uC800 \uCD5C\uC120\uC744 \uB2E4\uD569\uB2C8\uB2E4.'}</p>
                                </div>
                            </div>
                            <div className="col-12 mb-35">
                                <figure className="codam-benefits-visual mb-0">
                                    <img
                                        className="codam-benefits-visual__shape"
                                        src="assets/img/shape/line-round-2a.svg"
                                        alt=""
                                        aria-hidden="true"
                                    />
                                    <div className="codam-benefits-visual__frame feature-img-wrapper">
                                        <Tilt
                                            tiltMaxAngleX={6}
                                            tiltMaxAngleY={6}
                                            scale={1.03}
                                            transitionSpeed={1400}
                                            glareEnable={false}
                                        >
                                            <img
                                                className="codam-benefits-visual__img"
                                                src="assets/img/ilustration/ilus-01.svg"
                                                alt={ '\uCF54\uB2F4 \uBCF5\uC9C0\u00B7\uD61C\uD0DD \uC77C\uB7EC\uC2A4\uD2B8' }
                                            />
                                        </Tilt>
                                    </div>
                                </figure>
                            </div>
                            {benefitItems.map((item) => (
                                <div key={item.title} className="col-md-6 col-xl-4 mb-30">
                                    <div className="feature-style-one codam-benefits-card h-100 mb-0">
                                        <span className="top-arrow" aria-hidden="true"><i className="bi bi-arrow-up-right" /></span>
                                        <img
                                            className="front-icon codam-benefits-card__thumb"
                                            src={`assets/img/${item.icon}`}
                                            alt=""
                                        />
                                        <h2>{item.title}</h2>
                                        <p className="mb-0">{item.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="about-codam pt-100 pb-110 pt-lg-50 pb-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-8">
                                <div className="section-title-two mb-30">
                                    <h6 className="sub-title mb-20">근무 환경</h6>
                                    <h2 className="sect-title">{'\uCF54\uB2F4\uC774 \uB9CC\uB4E0 \uC77C\uD558\uAE30 \uC88B\uC740 \uD658\uACBD'}</h2>
                                </div>
                                <p>
                                    {'\uCF54\uB2F4\uC740 \uAD6C\uC131\uC6D0 \uD55C \uBA85 \uD55C \uBA85\uC774 \uC5ED\uB7C9\uC744 \uB9C8\uC74C\uAECF \uBC1C\uD718\uD560 \uC218 \uC788\uB294 \uD658\uACBD\uC744 \uB9CC\uB4E4\uAE30 \uC704\uD574'}
                                    {'\uB04A\uC784\uC5C6\uC774 \uAC1C\uC120\uD569\uB2C8\uB2E4. \uC88B\uC740 \uBB38\uD654\uB294 \uC8FC\uC5B4\uC9C0\uB294 \uAC83\uC774 \uC544\uB2C8\uB77C \uD568\uAED8 \uB9CC\uB4DC\uB294 \uAC83\uC774\uB77C \uBBFF\uC2B5\uB2C8\uB2E4.'}
                                </p>
                                <div className="row mt-35 codam-work-pillars">
                                    <div className="col-md-4 mb-25">
                                        <div className="feature-style-one codam-work-pillars__item h-100 mb-0">
                                            <span className="top-arrow" aria-hidden="true"><i className="bi bi-arrow-up-right" /></span>
                                            <img
                                                className="codam-work-pillars__icon"
                                                src="assets/img/about/work_img_1.png"
                                                alt="??? ?? ???"
                                            />
                                            <h5 className="mb-10">{'\uC218\uD3C9\uC801 \uC870\uC9C1'}</h5>
                                            <p className="mb-0">{'\uC9C1\uAE09\uBCF4\uB2E4 \uC5ED\uD560 \uC911\uC2EC\uC73C\uB85C \uC18C\uD1B5\uD569\uB2C8\uB2E4.'}</p>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-25">
                                        <div className="feature-style-one codam-work-pillars__item h-100 mb-0">
                                            <span className="top-arrow" aria-hidden="true"><i className="bi bi-arrow-up-right" /></span>
                                            <img
                                                className="codam-work-pillars__icon"
                                                src="assets/img/about/work_img_2.png"
                                                alt="?? ?? ???"
                                            />
                                            <h5 className="mb-10">{'\uBE60\uB978 \uC2E4\uD589'}</h5>
                                            <p className="mb-0">{'\uC544\uC774\uB514\uC5B4\uB97C \uBE60\uB974\uAC8C \uC2E4\uD5D8\uD558\uACE0 \uAC1C\uC120\uD569\uB2C8\uB2E4.'}</p>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-25">
                                        <div className="feature-style-one codam-work-pillars__item h-100 mb-0">
                                            <span className="top-arrow" aria-hidden="true"><i className="bi bi-arrow-up-right" /></span>
                                            <img
                                                className="codam-work-pillars__icon"
                                                src="assets/img/about/work_img_3.png"
                                                alt="??? ?? ???"
                                            />
                                            <h5 className="mb-10">{'\uC2EC\uB9AC\uC801 \uC548\uC804'}</h5>
                                            <p className="mb-0">{'\uC2E4\uD328\uB97C \uD559\uC2B5 \uC790\uC0B0\uC73C\uB85C \uC804\uD658\uD558\uB294 \uBB38\uD654\uB97C \uC9C0\uD5A5\uD569\uB2C8\uB2E4.'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="text-center mb-25">
                                    <img className="img-fluid" src="assets/img/about/work-environment.png" alt={ '\uCF54\uB2F4 \uC6CC\uD06C \uD658\uACBD' } />
                                </div>
                                <div className="row codam-work-stats">
                                    <div className="col-4 mb-20">
                                        <div className="feature-style-two codam-work-stats__card codam-work-stats__item h-100 mb-0">
                                            <h3 className="mb-0">2021</h3>
                                            <p className="mb-0">{'\uCF54\uB2F4 \uCC3D\uB9BD'}</p>
                                        </div>
                                    </div>
                                    <div className="col-4 mb-20">
                                        <div className="feature-style-two codam-work-stats__card codam-work-stats__item h-100 mb-0">
                                            <h3 className="mb-0">30+</h3>
                                            <p className="mb-0">{'\uD30C\uD2B8\uB108\uC0AC'}</p>
                                        </div>
                                    </div>
                                    <div className="col-4 mb-20">
                                        <div className="feature-style-two codam-work-stats__card codam-work-stats__item h-100 mb-0">
                                            <h3 className="mb-0">5+</h3>
                                            <p className="mb-0">{'\uC11C\uBE44\uC2A4 \uCD9C\uC2DC \uAD6D\uAC00'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="codam-feature pb-120 pb-lg-70">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-9 col-lg-10">
                                <div className="section-title-two text-center mb-35">
                                    <h6 className="sub-title mb-20">채용 안내</h6>
                                    <h2 className="sect-title">{'\uCF54\uB2F4\uACFC \uD568\uAED8 \uB354 \uB098\uC740 \uB0B4\uC77C\uC744 \uB9CC\uB4E4\uC5B4\uC694'}</h2>
                                    <p className="mt-20 mb-0">
                                        {'\uCF54\uB2F4\uC758 \uBB38\uD654\uC5D0 \uACF5\uAC10\uD558\uC2E0\uB2E4\uBA74 \uC5B8\uC81C\uB4E0\uC9C0 \uD300 \uD569\uB958\uB97C \uD658\uC601\uD569\uB2C8\uB2E4.'}
                                    </p>
                                </div>
                                <div className="text-center">
                                    <a className="theme_btn me-3 mb-15" href="mailto:admin@codam.co.kr">{'\uCC44\uC6A9 \uBB38\uC758\uD558\uAE30'}</a>
                                    <Link className="theme_btn border-btn mb-15" to="/">{'\uD648\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30'}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <FooterThree hideNewsletter />
            </div>
        </Fragment>
    )
}

export default About
